import { AddressLink, DaoOnChainDeployPoolCall } from 'Modules'

import { usePreparedTx } from 'hooks/dao-voting/use-prepared-tx'

/**
 * Create Refund / RWA Rewards Pool on-chain write (SRS 5.9).
 * The BE prepares the calldata for the contract it returns: PoolFactory
 * deployPool(params) for PTO NFT, GovernanceOrchestrator createRedemptionPool
 * (params) for ERC-3643. Either way the tx also opens the claim window on the
 * AssetStateMachine; the manager wallet sends it as is.
 */
export const usePoolFactoryContract = () => {
  const { sendPreparedTx } = usePreparedTx()

  const deployPoolOnChain = async (address: AddressLink, call: DaoOnChainDeployPoolCall) => {
    if (!call?.contractAddress) throw new Error('Pool factory address is missing')
    if (!call?.calldata) throw new Error('Deploy pool calldata is missing')

    return sendPreparedTx(address, { to: call.contractAddress, data: call.calldata })
  }

  return { deployPoolOnChain }
}
